import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from "react-router-dom";

function PermissionConsentBox(props) {
    const { showPermissionBox  , setShowPermissionBox } = props
    const navigate = useNavigate();
    const closePermissionBoxHandler = ()=>{
        setShowPermissionBox(false)
         navigate('/')
         window.location.reload();
    }
    return (
        <>
            <Modal show={showPermissionBox} animation={false}>
                <Modal.Header>
                    <Modal.Title>Mandatory Permission </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Please provide access to both Aadhaar and Apaar documents. If any of them does not exist, please create and upload the missing document in Digilocker.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => closePermissionBoxHandler()}>
                        Close
                    </Button>
                </Modal.Footer>

            </Modal>
        </>
    );
}

export default PermissionConsentBox;